module.exports = __webpack_public_path__ + "img/Icon material-drag-handle.71f082a7.svg";